import { createSelector } from '@reduxjs/toolkit';
export const specificFacetSearchStateSelector = createSelector((state, facetId) => ({
    facetSearchSelector: state.facetSearchSet[facetId],
}), ({ facetSearchSelector }) => {
    return facetSearchSelector;
});
